/**
 * 내부 유입 경로 추적용 ref 파라미터 상수
 * URL query string에 `ref=` 값으로 사용
 */
export const REF_SOURCE = {
  GENE_BROWSER_AD: 'gene-browser-ad',
} as const;

export type RefSource = (typeof REF_SOURCE)[keyof typeof REF_SOURCE];
